const Pagination = ({
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  totalPages,
  totalCount,
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6 p-4 bg-white border border-border rounded-lg">
      {/* Page Size Selector */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-text-secondary">Show:</span>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setCurrentPage(1);
          }}
          className="border border-border rounded-lg py-2 px-3 text-sm text-text-primary bg-white hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary transition cursor-pointer"
        >
          <option value="15">15</option>
          <option value="30">30</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      {/* Navigation */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 border border-border text-text-primary rounded-lg hover:bg-accent-teal-subtle hover:border-primary disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-primary transition text-sm font-medium"
        >
          Previous
        </button>

        <span className="text-sm text-text-primary font-medium px-3">
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className="px-4 py-2 border border-border text-text-primary rounded-lg hover:bg-accent-teal-subtle hover:border-primary disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-primary transition text-sm font-medium"
        >
          Next
        </button>
      </div>

      {/* Results Counter */}
      <div className="text-sm text-text-secondary">
        {totalCount ?? totalPages * pageSize} total results
      </div>
    </div>
  );
};

export default Pagination;
